/**
 * Variant-specific config for stats tab.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  FILTER_FIELDS,
  FILTER_FIELDS_LISTS,
  FILTER_FIELDS_GATEWAYS,
  FILTER_FIELDS_PATHS,
  FILTER_FIELDS_LANDERS,
  FILTER_FIELDS_OFFERS,
  FILTER_FIELDS_PHONE,
  FILTER_FIELDS_SOURCES,
  FILTER_FIELDS_TEXTS,
  GROUP_BY_OPTIONS,
  GROUP_BY_OPTIONS_LISTS,
  GROUP_BY_OPTIONS_GATEWAYS,
  GROUP_BY_OPTIONS_PATHS,
  GROUP_BY_OPTIONS_LANDERS,
  GROUP_BY_OPTIONS_OFFERS,
  GROUP_BY_OPTIONS_PHONE,
  GROUP_BY_OPTIONS_SOURCES,
  GROUP_BY_OPTIONS_TEXTS,
} from '../../shared/constants';
import type { StatsTabVariant } from './useStatsTabState.types';

const IMPRESSIONS_VARIANTS: StatsTabVariant[] = [
  'texts', 'lists', 'gateways', 'sources', 'phone', 'paths', 'landers', 'offers',
];

type FilterFieldDef = { key: string; label: string; type: 'numeric' | 'text' };
export function getFilterFieldsForVariant(variant: StatsTabVariant): readonly FilterFieldDef[] {
  const map: Record<StatsTabVariant, readonly FilterFieldDef[]> = {
    drops: FILTER_FIELDS,
    lists: FILTER_FIELDS_LISTS,
    gateways: FILTER_FIELDS_GATEWAYS,
    paths: FILTER_FIELDS_PATHS,
    landers: FILTER_FIELDS_LANDERS,
    offers: FILTER_FIELDS_OFFERS,
    phone: FILTER_FIELDS_PHONE,
    sources: FILTER_FIELDS_SOURCES,
    texts: FILTER_FIELDS_TEXTS,
  };
  return map[variant];
}

type GroupByOptionDef = { key: string; label: string };
export function getGroupByOptionsForVariant(variant: StatsTabVariant): readonly GroupByOptionDef[] {
  const map: Record<StatsTabVariant, readonly GroupByOptionDef[]> = {
    drops: GROUP_BY_OPTIONS,
    lists: GROUP_BY_OPTIONS_LISTS,
    gateways: GROUP_BY_OPTIONS_GATEWAYS,
    paths: GROUP_BY_OPTIONS_PATHS,
    landers: GROUP_BY_OPTIONS_LANDERS,
    offers: GROUP_BY_OPTIONS_OFFERS,
    phone: GROUP_BY_OPTIONS_PHONE,
    sources: GROUP_BY_OPTIONS_SOURCES,
    texts: GROUP_BY_OPTIONS_TEXTS,
  };
  return map[variant];
}

export function isImpressionsDefaultVariant(variant: StatsTabVariant): boolean {
  return IMPRESSIONS_VARIANTS.includes(variant);
}

export function getDefaultSortForVariant(variant: StatsTabVariant): { field: string; dir: 'asc' | 'desc' } {
  return variant === 'drops'
    ? { field: 'dropList', dir: 'desc' }
    : { field: 'impressions', dir: 'desc' };
}

export function getDefaultGroupByForVariant(variant: StatsTabVariant): string {
  return variant === 'texts' ? 'text' : 'none';
}
